import React from 'react'

import InputField from 'src/components/InputField'

const ProjectDesignation = ({
  i18n, projectId, setProjectId, prompt, projects, error, commonInputProps,
}) =>
  <InputField
    {...commonInputProps(i18n.t('project_designation'), true)}
    type="select"
    id="project_designation"
    value={projectId}
    onChange={e => setProjectId(e.target.value)}
    error={error}
    options={[
      ...(prompt ? [{ label: i18n.t('project_designation_prompt'), value: '' }] : []),
      ...projects.map(project => ({ label: project.name, value: project.id }))
    ]}
  />

export default ProjectDesignation
